









import { BaseSelect, selectName } from '#components/baseSelect';

import { NAME } from '../constants';
import { apiProvider } from '../api';

type DataType = {
	BANKUCET_ID: number;
	BANKA_TXT: string;
	BANKA_BIC: string;
	BANKA_UCET: string;
	POPIS: number;
	BANKA_IBAN: string;
};

export default BaseSelect.extend({
	name: selectName(NAME),
	props: {
		labelKey: { type: String, default: 'BANKUCET_ID' },
		isClearable: { type: Boolean, default: true },
	},
	data() {
		return {
			storeObject: NAME,
			valueFieldName: 'BANKUCET_ID',
			apiProvider,
			emptyObject: {
				isClear: true,
				value: null,
				text: null,
				osobniCis: null,
			},
		};
	},
	methods: {
		dbToBaseMapper(data: DataType) {
			return {
				value: data.BANKUCET_ID,
				text: data.BANKA_TXT,
				POPIS: data.POPIS,
				BANKUCET_ID: data.BANKUCET_ID,
				BANKA_UCET: data.BANKA_UCET,
				BANKA_TXT: data.BANKA_TXT,
				BANKA_BIC: data.BANKA_BIC,
				BANKA_IBAN: data.BANKA_IBAN,
			};
		},
	},
});
